import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { getBrandUsers } from "../../../services/StoreUsers/PostStoreUsers";
import { ProgressSpinner } from "primereact/progressspinner";
import AdminMenu from "../../AdminMenu";
import { getStoreNotification } from "../../../services/StoreNotification/StoreNotification";
import StoreNotificationStatusChange from "./StoreNotificationStatusChange";
import StoreNotificationAddModal from "./StoreNotificationAddModal";
import ActiveInActiveFilter from "./ActiveInActiveFilter";

const StoreNotificationView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, StoreData } = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);
  const [storeNotificationData, setStoreNotificationData] = useState([]);
  const [storeNotificationDataAll, setStoreNotificationDataAll] = useState([]);
  const [storeUserList, setStoreUserList] = useState([]);
  const [
    storeNotificationAddModalVisible,
    setStoreNotificationAddModalVisible,
  ] = useState(false);
  const [loading, setLoading] = useState(false);

  const [activeInActiveFilterVisible, setActiveInActiveFilterVisible] =
    useState(false);

  const { brandProfileData, userProfileRole } = getUserData();
  let brandId = brandProfileData.id;
  let userRole = userProfileRole;

  const fetchPriceCode = () => {
    setLoading(true);
    const data = {
      storeId: id,
    };
    getStoreNotification(data)
      .then((response) => {
        if (!response.data.error) {
          const res = response.data;
          setStoreNotificationDataAll(res);
          const NewRes = res.filter((item) => item.status === true);
          setStoreNotificationData(NewRes);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    getBrandUsers(brandId)
      .then((response) => {
        if (!response.data.error) {
          const users = response.data;
          setStoreUserList(users);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchPriceCode();
  }, []);

  const receiveDataFromActiveInActiveFilter = (selectedValue) => {
    const newMap = storeNotificationDataAll?.filter((service) =>
      selectedValue?.some((item) => item.value === service?.status),
    );
    setStoreNotificationData(newMap);
  };

  const receiveDataFromBrandStoreUserStatusChange = ({ success }) => {
    if (success) {
      fetchPriceCode();
    }
  };

  const renderStoreUserCardItem = (data) => {
    return data?.map((item, index) => {
      return (
        <div key={item.id}>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Template Type :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.brandNotificationTemplate.templateType.templateType.replace(
                      /_/g,
                      " ",
                    )}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Status
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {item.status === true ? "Active" : "DeActive"}{" "}
                    </p>
                  </div>
                  {item.brandNotificationTemplate.status === true && (
                    <div>
                      {userRole === "BY_FRANCHISE_ADMIN" ? (
                        ""
                      ) : (
                        <StoreNotificationStatusChange
                          status={item.status}
                          sendDataToStoreConfig={
                            receiveDataFromBrandStoreUserStatusChange
                          }
                          editData={item}
                          brandId={brandId}
                          storeId={id}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/StoreConfigList", {
                      state: {
                        id: id,
                        StoreData: StoreData,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Store Notification
              </p>
            </div>
          </div>
          <div
            onClick={() => setActiveInActiveFilterVisible(true)}
            className="flex justify-content-center align-items-center mx-2 cursor-pointer"
          >
            <div>
              <img
                src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
                style={{ width: 27 }}
              />
            </div>
          </div>
          {userRole === "BY_FRANCHISE_ADMIN" ? (
            ""
          ) : (
            <div
              className="flex justify-content-center align-items-center cursor-pointer mr-4"
              onClick={() => setStoreNotificationAddModalVisible(true)}
            >
              <img src="images/plus.png" alt="plus" style={{ width: 30 }} />
            </div>
          )}
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : storeNotificationData?.length > 0 ? (
          <div>
            <div>{renderStoreUserCardItem(storeNotificationData)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No Notification Found</p>
          </div>
        )}
      </div>
      <StoreNotificationAddModal
        storeNotificationAddModalVisible={storeNotificationAddModalVisible}
        setStoreNotificationAddModalVisible={
          setStoreNotificationAddModalVisible
        }
        sendDataToStoreConfig={receiveDataFromBrandStoreUserStatusChange}
        brandId={brandId}
        storeUserList={storeUserList}
        storeId={id}
      />
      <ActiveInActiveFilter
        setActiveInActiveFilterVisible={setActiveInActiveFilterVisible}
        activeInActiveFilterVisible={activeInActiveFilterVisible}
        sendDataToActiveInActiveFilter={receiveDataFromActiveInActiveFilter}
      />
      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default StoreNotificationView;
